/**
 * Basic tab control.
 *
 * ## Events
 * Name | Arguments | Description
 * --- | --- | ---
 * start | The tab initializer (see `initialize`) and the index of the tab initializer in the input list. | Fired when a tab is first entered.
 * enter | Same. | Fired whenever a tab is entered.
 * leave | Same. | Fired whenever a tab is left.
 *
 * ## Properties
 * Name | Description
 * --- | ---
 * currentTab | Gets and sets the integer index of the currently displayed tab in the input list.
 */

import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
export default Backbone.View.extend({
  className: "tab-view",
  template: _.template(
    '<ul class="nav nav-tabs" role="tablist"></ul><div class="tab-content <%- (autoToggle ? "" : "hidden-xs")%>"></div>'
  ),

  /**
   * Initializes a tab control.
   * @param  {object} options The options hash.
   * @param {Array} options.tabs An array of tab initializers.
   * @param {Backbone.View} options.tabs[].view Backbone view to place within the tab.
   * @param {string} options.tabs[].title The title of the tab.
   * @param {Integer} options.initialTab:0 The index of the tab to display when first rendering the view.
   * @param {String} options.prefix:tab-item The ID prefix to use for identifying tabs.
   * @param {Function} [options.tabHref] The function which generates the `href` attribute for each tab. Arguments are id of tab content pane, index of the tab info item, and index which can be used to set the current tab.
   * @param {Boolean} options.autoToggle:true True to set up the tabs as functional bootstrap tabs, otherwise false.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      tabs: [
        /*{
                	view: null, //Backbone view to place within the tab
                	title: '' //title for the tab
                }*/
      ], //array of tab initializers
      initialTab: 0, //starting tab index
      prefix: "tab-item",
      tabHref: function (id) {
        return "#" + id;
      },
      autoToggle: true,
    });

    this._currentTab = null;
    var self = this;

    if (this.options.el) {
      this.options.tabs = this._parseTabs();
      this._currentTab = this.options.tabs[this.options.initialTab];
    }

    Object.defineProperty(this, "currentTab", {
      get: function () {
        return self._currentTab;
      },
      set: function (tab) {
        self._setCurrentTab(tab);
      },
    });
  },

  /**
   * Parse tabs from existing source.
   * @private
   */
  _parseTabs: function () {
    var tabs = [];
    var self = this;

    this.$(".nav-tabs li").each(function (index) {
      var tab = {};
      var $link = $(this).children("a");

      tab.title = $link.html();
      tab.view = new Backbone.View({
        el: self.$("#" + self.options.prefix + "-" + index).children()[0],
      });

      $(this).data("tab", tab);
      tab.view.$el.data("tab", tab);

      tabs.push(tab);
    });

    return tabs;
  },

  render: function () {
    this.$el.html(this.template(this.options));
    var tabList = this.$("ul");
    var self = this;

    _.each(this.options.tabs, function (tab, index) {
      var id = self.options.prefix + "-" + index;
      var tabParent = $(
        '<div id="' + id + '" class="tab-pane" role="tabpanel"></div>'
      );
      var href = self.options.tabHref(id, index, index);
      var tabEl = $(
        '<li role="presentation"><a href="' +
          href +
          '" aria-controls="' +
          id +
          '" role="tab" ' +
          (self.options.autoToggle ? 'data-toggle="tab"' : "") +
          ">" +
          tab.title +
          "</a></li>"
      );

      tab.view.$el.data("tab", tab);
      tabEl.data("tab", tab);

      if (index == self.options.initialTab) {
        tabEl.addClass("active");
        tabParent.addClass("active");
      }

      tabEl.on("shown.bs.tab", function () {
        self.currentTab = tab;
      });
      tabList.append(tabEl);
      tabParent.append(tab.view.$el);
      tabParent.appendTo(self.$(".tab-content"));
    });

    this.currentTab = this.options.initialTab;
  },

  _setCurrentTab: function (tab) {
    var oldTab = this.currentTab;
    var oldTabIndex = this.options.tabs.indexOf(oldTab);
    var newTab;
    var newTabIndex;

    if (_.isNumber(tab)) {
      newTabIndex = tab;
      newTab = this.options.tabs[newTabIndex];
    } else {
      newTab = tab;
      newTabIndex = this.options.tabs.indexOf(newTab);
    }

    this.trigger("leave", oldTab, oldTabIndex);

    if (!this.options.autoToggle) {
      this.$(".nav-tabs li").removeClass("active");
      this.$(".tab-pane").removeClass("active");
    }

    if (newTab) {
      if (!newTab._started) {
        this.trigger("start", newTab, newTabIndex);
        newTab._started = true;
      }

      if (!this.options.autoToggle) {
        var $newTab = this.$(".nav-tabs li").eq(newTabIndex);
        var $newTabContent = this.$(
          "#" + this.options.prefix + "-" + newTabIndex
        );

        $newTab.addClass("active");
        $newTabContent.addClass("active");
      }

      this.trigger("enter", newTab, newTabIndex);
    }

    this._currentTab = newTab;
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/TabView.js
// module id = 104
// module chunks = 1